import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
	MatAutocompleteModule, MatButtonModule, MatCheckboxModule, MatDatepickerModule, MatNativeDateModule,
	MatFormFieldModule, MatInputModule, MatRadioModule, MatSelectModule, MatSliderModule,
	MatSlideToggleModule, MatDialogModule,
	MatSnackBarModule, MatProgressBarModule
} from '@angular/material';
import { MomentDateModule } from '@angular/material-moment-adapter';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClientModule } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxSkltnModule, SkltnConfig } from 'ngx-skltn';
const skltnConfig: SkltnConfig = {
	rectRadius: 4,
	flareWidth: '150px',
	bgFill: '#f1f1f1',
	flareFill: 'rgba(255,255,255, 0.5)',
};

export const MY_FORMATS = {
    display:{
        dateInput: 'YYYY/MM/DD',
        monthYearLabel : 'MMM YYYY',
    }
}

import { NgbDate, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { OrderComponent } from './order/order.component';
import { AppRoutingModule } from './app-routing.module';
import { HeaderComponent } from './components/header/header.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LogonComponent } from './components/logon/logon.component';
import { EdayComponent } from './order/eday/eday.component';
import { SdayComponent } from './order/sday/sday.component';
import { WriteComponent } from './order/write/write.component';
import { AccountComponent } from './account/account.component';
import { ListComponent } from './list/list.component';
import { PartnerComponent } from './partner/partner.component';
import { PaymentComponent } from './payment/payment.component';
import { RegComponent } from './partner/reg/reg.component';
import { DelComponent } from './confirm/del/del.component';
import { AddrComponent } from './partner/addr/addr.component';
import { LoginComponent } from './login/login.component';
import { MemberComponent } from './admin/member/member.component';
import { ConfigComponent } from './admin/config/config.component';
import { UserComponent } from './account/user/user.component';
import { UserregComponent } from './account/user/userreg/userreg.component';
import { AdminComponent } from './admin/admin.component';
import { AdmheaderComponent } from './components/admheader/admheader.component';
import { AgreeComponent } from './admin/apps/agree/agree.component';
import { PrivacyComponent } from './admin/apps/privacy/privacy.component';
import { GpsComponent } from './admin/apps/gps/gps.component';
import { AppsComponent } from './admin/apps/apps.component';
import { RequestComponent } from './admin/request/request.component';
import { MbregComponent } from './admin/member/mbreg/mbreg.component';
import { MbmodComponent } from './admin/member/mbmod/mbmod.component';
import { SmsComponent } from './admin/sms/sms.component';
import { RviewComponent } from './admin/request/rview/rview.component';
import { SmshistoryComponent } from './admin/sms/smshistory/smshistory.component';
import { SmspayComponent } from './admin/sms/smspay/smspay.component';
import { SmsorderComponent } from './admin/sms/smsorder/smsorder.component';
import { Error404Component } from './error404/error404.component';
import { NotAuthorizedComponent } from './not-authorized/not-authorized.component';
import { OviewComponent } from './order/oview/oview.component';
import { PeriodComponent } from './admin/period/period.component';
import { BasicComponent } from './admin/basic/basic.component';
import { InquiryComponent } from './admin/inquiry/inquiry.component';
import { UsedComponent } from './agree/used/used.component';
import { JoinComponent } from './join/join.component';

export const MY_DATE_FORMATS = {
	parse: {
		dateInput: 'YYYY-MM-DD',
	},
	display: {
		dateInput: 'YYYY-MM-DD',
		monthYearLabel: 'YYYY MMMM',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'YYYY MMMM'
	},
};

@NgModule({
	declarations: [
		AppComponent,
		MainComponent,
		OrderComponent,
		HeaderComponent,
		LogonComponent,
		EdayComponent,
		SdayComponent,
		WriteComponent,
		AccountComponent,
		ListComponent,
		PartnerComponent,
		PaymentComponent,
		RegComponent,
		DelComponent,
		AddrComponent,
		LoginComponent,
		MemberComponent,
		ConfigComponent,
		UserComponent,
		UserregComponent,
		AdminComponent,
		AdmheaderComponent,
		AgreeComponent,
		PrivacyComponent,
		GpsComponent,
		AppsComponent,
		RequestComponent,
		MbregComponent,
		MbmodComponent,
		SmsComponent,
		RviewComponent,
		SmshistoryComponent,
		SmspayComponent,
		SmsorderComponent,
		Error404Component,
		NotAuthorizedComponent,
		OviewComponent,
		PeriodComponent,
		BasicComponent,
		InquiryComponent,
		UsedComponent,
		JoinComponent,
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		MatAutocompleteModule,
		MatButtonModule,
		MatCheckboxModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatFormFieldModule,
		MatInputModule,
		MatRadioModule,
		MatSelectModule,
		MatSliderModule,
		MatSlideToggleModule,
		MatDialogModule,
		MatSnackBarModule,
		ReactiveFormsModule,
		HttpClientModule,
		NgxSpinnerModule,
		MatProgressBarModule,
		NgxSkltnModule.forRoot(skltnConfig),
		NgbModule,
		AngularEditorModule,
		MomentDateModule
	],
	providers: [
		MatDatepickerModule,
		MatNativeDateModule,
		{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
		{ provide: MAT_DATE_LOCALE, useValue: 'ko-KR' }
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
	entryComponents: [
		DelComponent,
		WriteComponent,
		SdayComponent,
		EdayComponent,
		AddrComponent,
		LoginComponent,
		UserregComponent,
		MbregComponent,
		MbmodComponent,
		OviewComponent
	]
})
export class AppModule { }
